import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Link as RouterLink} from 'react-router-dom';
//MUI
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
//DS
import {hooks, PasswordDs} from 'lib.front';
import {transformacion} from 'lib.common';
import {esquemaCampos, esquemaValidacion} from './esquemas';
import * as keys from 'src/config/keys';
import useSendMessage from 'src/libBack/hooks/useSendMessage';
import RestablecerPass from './restablecerPass/RestablecerPass';
import {makeStyles} from 'tss-react/mui';
import {SCRN_DS_SIGN_UP} from 'src/Routes/screens';
import {PRODUCTOS_DISPONIBLES_SIGNUP} from 'src/constants/productos';

const useStyles = makeStyles()(theme => ({
   signInButton: {
      boxShadow:
         '0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)',
      backgroundColor: '#FFFFFF',
      color: 'black',
      '&:hover': {
         backgroundColor: '#d5d5d5'
      },
      padding: theme.spacing(1, 3)
   }
}));

function DSLogin({appName, logInApi, modal}) {
   const {classes} = useStyles();
   const {sendMessagePopUp} = useSendMessage();
   const {
      campos,
      existeError: existeErrorInput,
      handleOnChange,
      validarTodos
   } = hooks.useValidacion(esquemaCampos, esquemaValidacion);
   const [errMsg, setErrMsg] = useState('');

   const [loadingToken, setloadingToken] = useState(false);

   const paramsQuery = transformacion.getHashQueryString(window.location.search);
   const allowSignUp = PRODUCTOS_DISPONIBLES_SIGNUP.some(
      curr => curr.codProducto === paramsQuery.client_id
   );

   async function handleSignIn() {
      setloadingToken(true);
      const esOk = await validarTodos();
      if (esOk) {
         const audience = paramsQuery.client_id || keys.appId;
         const appScope = paramsQuery.scope || keys.appScope;
         const body = {
            grant_type: 'password',
            username: campos.user.valor,
            password: transformacion.encodeBase64(campos.pass.valor),
            audience,
            scope: `openid profile email ${appScope}`
         };
         const tokenUri = transformacion.appendUrl(keys.urls.backEnd, '/oauth/token');
         try {
            //procesar peticion de token
            const res = await fetch(tokenUri, {
               method: 'POST',
               mode: 'cors',
               credentials: 'include',
               headers: {
                  'Content-Type': 'application/json'
               },
               body: JSON.stringify(body)
            });

            if (!res.ok) {
               const text = await res.text();
               throw new Error(text);
            }

            let data = await res.json();
            setloadingToken(false);

            let redirectString = paramsQuery['redirect_uri'];
            if (!redirectString) {
               redirectString = transformacion.appendUrl(
                  transformacion.appendUrl(window.location.origin, keys.baseName),
                  keys.callbackRoute
               );
            }
            if (paramsQuery.popup === 'true') {
               sendMessagePopUp(data.access_token, redirectString);
            } else {
               let redirect_url = new URL(redirectString);
               redirect_url.searchParams.append('token', data.access_token);
               redirect_url.searchParams.append('state', data.state);
               redirect_url.searchParams.append('token_type', data.token_type);
               redirect_url.searchParams.append('email', campos.user.valor);
               if (paramsQuery['origin_uri']) {
                  redirect_url.searchParams.append('origin_uri', paramsQuery['origin_uri']);
               }
               window.location.replace(redirect_url.toString());
            }
         } catch (err) {
            let errormsg = JSON.parse(err.message);
            if (errormsg && errormsg.error) {
               setErrMsg(errormsg.error);
            } else {
               setErrMsg(err.toString());
            }
            setloadingToken(false);
         }
      } else {
         setloadingToken(false);
      }
   }

   return (
      <Container style={{height: '100%'}}>
         <Grid
            style={{height: '100%'}}
            container
            justifyContent="flex-end"
            alignItems="flex-end"
            spacing={2}
         >
            <Grid container item xs={12} justifyContent="center">
               <Card style={{maxWidth: 400, padding: 16}}>
                  <CardMedia
                     component="img"
                     height="auto"
                     image="https://www.dscont.pe/dsServices/images/ds-iso9001-logo.png"
                     alt="Data Service Capacitacion SRL."
                     style={{
                        width: '90%',
                        padding: 2,
                        justifySelf: 'center'
                     }}
                  />
                  <CardContent>
                     <Grid container spacing={1}>
                        <Grid item xs={12}>
                           <Typography gutterBottom variant="h5" align="center" color="textPrimary">
                              Iniciar Sesión
                           </Typography>
                           {appName && (
                              <Typography
                                 gutterBottom
                                 variant="subtitle1"
                                 align="center"
                                 color="textPrimary"
                              >
                                 Ir a {appName}
                              </Typography>
                           )}
                        </Grid>
                        <Grid item xs={12}>
                           <TextField
                              name="user"
                              value={campos.user.valor}
                              onChange={handleOnChange}
                              error={campos.user.error !== ''}
                              helperText={campos.user.error}
                              label="Email"
                              fullWidth
                              sx={{borderRadius: '10px'}}
                              variant="standard"
                           />
                        </Grid>
                        <Grid item xs={12}>
                           <PasswordDs
                              name="pass"
                              value={campos.pass.valor}
                              onChange={handleOnChange}
                              error={campos.pass.error !== ''}
                              helperText={campos.pass.error}
                              label="Contraseña"
                              toggle
                              fullWidth
                              variant="standard"
                           />
                        </Grid>
                        <Grid item xs={12}>
                           <Typography
                              variant="subtitle2"
                              align="center"
                              color="error"
                              component="p"
                           >
                              {errMsg}
                           </Typography>
                        </Grid>
                        {loadingToken && (
                           <Grid container item xs={12}>
                              <Grid item xs={12}>
                                 <Typography variant="body2" color="textSecondary">
                                    Verificando Credenciales
                                 </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                 <LinearProgress />
                              </Grid>
                           </Grid>
                        )}
                        <Grid container item xs={12} justifyContent="center">
                           <Button
                              onClick={handleSignIn}
                              type="submit"
                              size="large"
                              className={classes.signInButton}
                           >
                              Acceder
                           </Button>
                        </Grid>
                        <Grid container item xs={12} justifyContent="center">
                           <RestablecerPass />
                        </Grid>
                        {allowSignUp && (
                           <Grid item xs={12}>
                              <Typography
                                 variant="subtitle2"
                                 align="center"
                                 color="textSecondary"
                                 component="p"
                              >
                                 <RouterLink to={`${SCRN_DS_SIGN_UP.to}${window.location.search}`}>
                                    No tiene cuenta? Haga click aqui para crear una
                                 </RouterLink>
                              </Typography>
                           </Grid>
                        )}
                     </Grid>
                  </CardContent>
               </Card>
            </Grid>
            <Grid container item xs={12}>
               {!modal && (
                  <>
                     <Grid item xs={3}>
                        <Typography
                           variant="subtitle2"
                           align="center"
                           color="textSecondary"
                           component="p"
                        >
                           <Link target="_blank" href="https://www.dscont.pe/" underline="hover">
                              Política de Privacidad
                           </Link>
                        </Typography>
                     </Grid>
                     <Grid item xs={3}>
                        <Typography
                           variant="subtitle2"
                           align="center"
                           color="textSecondary"
                           component="p"
                        >
                           <Link target="_blank" href="https://www.dscont.pe/" underline="hover">
                              Términos y Condiciones
                           </Link>
                        </Typography>
                     </Grid>
                  </>
               )}
               <Grid item xs={modal ? 12 : 6}>
                  <Typography
                     variant="subtitle2"
                     align="center"
                     color="textSecondary"
                     component="p"
                  >
                     Copyright©{new Date().getFullYear()}{' '}
                     <Link target="_blank" href="https://www.dscont.pe/" underline="hover">
                        DsContSoftware
                     </Link>
                     . Todos los derechos reservados.
                  </Typography>
               </Grid>
            </Grid>
         </Grid>
      </Container>
   );
}
DSLogin.propTypes = {
   /**
    * Si es __true__ el componente no realizara ninguna redirección y ejecutara la funcion onLoginSuccess.
    */
   modal: PropTypes.bool,
   /**
    * Funcion a ejecutar cuando el se ha realizado un login exitoso.
    */
   onLoginSuccess: PropTypes.func
};
DSLogin.defaultProps = {
   modal: false
};
export default DSLogin;
